import type { PublicConfig } from '../../config/public.types'

declare const __PUBLIC_CONFIG__: PublicConfig

export const publicConfig = __PUBLIC_CONFIG__
